import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, auto));
    max-width: 100%;
    width: 100%;
    gap: 1.5rem;
    align-items: start;

    > form {
      width: 280px;

      > :not(:first-child) {
        margin-top: 0.5rem;
      }
    }
  `}
`
